// Используется для сохранения последних
// выбранных банков при оплате СБП
export const LOCAL_STORAGE_USED_BANKS = 'USED_BANKS'
